import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	taa015Titulo: yup.string().required(translate("Título não confere")).oneOf([yup.ref("taa015TituloConfirmation")], translate("Título não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	taa015Titulo : yup.string().required(translate("Descrição é requerida")),
	taa015Estrategia : yup.string().required(translate("Descrição é requerida")),
	taa015Descricao  : yup.string().required(translate("Descrição é requerida")),
	taa015Acao : yup.string().required(translate("Descrição é requerida")),
	taa015Forca: yup.boolean(),
	taa015Fraqueza: yup.boolean(),
	taa015Oportunidade: yup.boolean(),
	taa015Ameaca: yup.boolean()
});

export {addAndChangeSchema,deleteSchema};
